import { apiFetch } from './api';

export interface Package {
    id: string;
    title: string;
    description: string;
    price: number;
    type: 'hajj' | 'umrah';
    duration: string;
    dates: string;
    features: string[];
    image_url: string;
    is_active: boolean;
    created_at: string;
}

export const packageService = {
    async getPackages(type?: 'hajj' | 'umrah') {
        const data = await apiFetch('/packages');
        let packages = data as Package[];
        if (type) {
            packages = packages.filter(p => p.type === type);
        }
        return packages;
    },

    async getAllPackagesAdmin() {
        const data = await apiFetch('/admin/packages');
        return data as Package[];
    },

    async createPackage(packageData: any) {
        const data = await apiFetch('/admin/packages', {
            method: 'POST',
            body: JSON.stringify(packageData)
        });
        return data as Package;
    },

    async updatePackage(id: string, updates: any) {
        const data = await apiFetch(`/admin/packages/${id}`, {
            method: 'PUT',
            body: JSON.stringify(updates)
        });
        return data as Package;
    },

    async deletePackage(id: string) {
        await apiFetch(`/admin/packages/${id}`, {
            method: 'DELETE'
        });
    }
};
